import { Button, LoadingButton } from '@one-thd/sui-atomic-components';
import React from 'react';
import { IAddReceiptDrawerFooter } from '../../../../models/purchase-history/add-receipt';

export const AddReceiptDrawerFooter = ({
  closeDrawer,
  handleButtonClick,
  isLoading,
  primaryButtonText,
  reset,
  secondaryButtonText,
}: IAddReceiptDrawerFooter) => {
  return (
    <div className="ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col sui-p-4 sui-px-0 sui-mt-8">
      <LoadingButton
        loading={isLoading}
        onClick={handleButtonClick}
        variant="primary"
      >
        {primaryButtonText}
      </LoadingButton>
      <Button
        disabled={isLoading}
        onClick={() => {
          closeDrawer();
          reset();
        }}
        variant="secondary"
      >
        {secondaryButtonText}
      </Button>
    </div>
  );
};
